import type { ComponentType, SVGProps } from 'react'
import {
  Building2,
  CalendarDays,
  Landmark,
  Lightbulb,
  User,
  Users,
} from 'lucide-react'
import type { EntityKind } from '@/lib/types/universe'

type IconType = ComponentType<SVGProps<SVGSVGElement>>

/** Icon, singular label and plural group label per entity kind. */
export const KIND_META: Record<
  EntityKind,
  { icon: IconType; label: string; plural: string }
> = {
  client: { icon: Building2, label: 'Client', plural: 'Clients' },
  team_member: { icon: Users, label: 'Team', plural: 'Team' },
  company: { icon: Landmark, label: 'Company', plural: 'Companies' },
  person: { icon: User, label: 'Person', plural: 'People' },
  solution: { icon: Lightbulb, label: 'Solution', plural: 'Solutions' },
  meeting: { icon: CalendarDays, label: 'Meeting', plural: 'Meetings' },
}
